import React, { useState, useEffect } from "react";
import styles from "./PayoutSubAccountLoadScreen.module.css";
import moment from "moment"
import { getUserProfile } from "../../../../helpers/profile_helper";
export default function PayoutSubAccountLoadScreen({ selectedCompany, selectedAccount, apiService, onSubmit }) {
  const [load_payout_master_access, setLoadPayoutMasterAccess] = useState('false')
  const [is_sub_account_detials_loading, setIsSubAccountDetailsLoading] = useState(false)
  const [masterAccount, setMasterAccount] = useState({});
  const [numbericMasterAccount, setNumericMasterAccount] = useState(0)
  const [subAccounts, setSubAccounts] = useState([]);
  const [selectedSubId, setSelectedSubId] = useState("");
  const [amount, setAmount] = useState("");
  const [confirmAmount, setConfirmAmount] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedSub, setSelectedSub] = useState(null);
  const [subLoads, setSubLoads] = useState([]);
  const [lastSubLoad, setLastSubLoad] = useState(null);
  const [numericAmount, setNumericAmount] = useState(0);
  const [amountsMatch, setAmountsMatch] = useState(false);
  const [positive, setPositive] = useState(false);
  const [withinBalance, setWithinBalance] = useState(false);
  const [duplicate, setDuplicate] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const [selected_sub_account, setSelectedSubAccount] = useState({})
  const [adjustment_ref, setAdjustmentRef] = useState('')
  const [user_profile, setUserProfile] = useState({})
  const [is_confirm_enabled, setIsConfirmEnabled] = useState(true)
  const [is_authorized, setIsAuthorized] = useState(false)
  const [is_loading, setIsLoading] = useState(false)
  const defaultMasterAccount = {
    id: "PA-MASTER",
    name: "Payout-Master",
    balance: 3_200_000,
  };

  const defaultSubAccounts = [
    {
      id: "SUB-RMI",
      name: "RMI Payout",
      balance: 450_000,
      loads: [
        { id: "RMI-005", amount: 90_000, timestamp: Date.now() - 2 * 3600 * 1000 },
        { id: "RMI-004", amount: 70_000, timestamp: Date.now() - 26 * 3600 * 1000 },
        { id: "RMI-003", amount: 60_000, timestamp: Date.now() - 50 * 3600 * 1000 },
        { id: "RMI-002", amount: 85_000, timestamp: Date.now() - 74 * 3600 * 1000 },
        { id: "RMI-001", amount: 50_000, timestamp: Date.now() - 98 * 3600 * 1000 },
      ],
    },
    {
      id: "SUB-XYZ",
      name: "Xyz Payout",
      balance: 300_000,
      loads: [
        { id: "XYZ-003", amount: 120_000, timestamp: Date.now() - 4 * 3600 * 1000 },
        { id: "XYZ-002", amount: 100_000, timestamp: Date.now() - 30 * 3600 * 1000 },
        { id: "XYZ-001", amount: 80_000, timestamp: Date.now() - 70 * 3600 * 1000 },
      ],
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true)
        var user_profile = await getUserProfile();
        setUserProfile(user_profile);
        var response = await apiService({ method: "post", path: "/user/fund_sub_account_master_info", payload: { company: selectedCompany, account: selectedAccount } });

        // if(response.data.is_authorized==false){
        setIsAuthorized(response.data.is_authorized)
        setIsLoading(false)
        // } 
        // API call to fetch master account
        if (response.data.load_payout_master && response.data.load_payout_master == 'false') {
          setLoadPayoutMasterAccess('false')
          return;
        }
        setLoadPayoutMasterAccess('true')
        var master_account_balance = response.data.master_account_balance;
        master_account_balance.name = master_account_balance.ledger_label;
        setMasterAccount(response.data.master_account_balance);

        // API call to fetch sub-accounts and their last 5 loads
        setSubAccounts(response.data.sub_account_balances);
      } catch (error) {
        console.error("API fetch failed, using default values:", error);
        setMasterAccount(defaultMasterAccount);
        setSubAccounts(defaultSubAccounts);
      }
    };

    fetchData();
  }, [selectedCompany, selectedAccount]);

  useEffect(() => {
    // Set initial selectedSubId
    // if (subAccounts.length && !selectedSubId) {
    //   setSelectedSubId(subAccounts[0]?.id ?? "");
    // }
    // Find selected sub-account
    // const newSelectedSub = subAccounts.find((s) => s.id === selectedSubId) ?? null;
    // setSelectedSub(newSelectedSub);

    // Set subLoads
    const newSubLoads = subLoads
    // setSubLoads(newSubLoads);

    // Set lastSubLoad
    setLastSubLoad(newSubLoads[0] ?? null);

    //master load account balance
    const newMasterAccountBalance = masterAccount.balance;
    setNumericMasterAccount(parseFloat(newMasterAccountBalance) || 0)
    // Calculate numeric amount
    const newNumericAmount = parseFloat(amount) || 0;
    setNumericAmount(newNumericAmount);

    // Check if amounts match
    setAmountsMatch(amount !== "" && amount === confirmAmount);

    // Check if amount is positive
    setPositive(newNumericAmount > 0);

    // Check if within balance
    setWithinBalance(selected_sub_account ? newNumericAmount <= newMasterAccountBalance : false);

    // Check for duplicate
    setDuplicate(newSubLoads[0] && newNumericAmount === newSubLoads[0].amount);

    // Validate
    setIsValid(
      newNumericAmount > 0 &&
      amount !== "" &&
      amount === confirmAmount &&
      selected_sub_account &&
      newNumericAmount <= masterAccount.balance &&
      !(newSubLoads[0] && newNumericAmount === newSubLoads[0].amount)
    );
  }, [subAccounts, selectedSubId, amount, confirmAmount]);

  const handleSubmitAttempt = () => {
    var newAdustment_ref = moment().format('YYYYMMDDHHmmss') + '-SubAccount-Load'
    if (!isValid) return;
    setAdjustmentRef(newAdustment_ref)
    if (!isValid) return;
    setDialogOpen(true);
  };
  const handleSubAccountSelection = async (ledger_label) => {
    setIsSubAccountDetailsLoading(true);
    setSelectedSubId(ledger_label)

    var response = await apiService({ method: "post", path: "/user/fund_sub_account_balance_and_loads", payload: { company: ledger_label, account: 'TransactionAccount' } });
    var sub_account_balance = response.data.sub_account_blance;
    var latest_loads = response.data.latest_adjustments;
    setSelectedSubAccount(sub_account_balance);
    setSubLoads(latest_loads);
    setIsSubAccountDetailsLoading(false)
  }
  const handleConfirm = async () => {
    setIsConfirmEnabled(false);
    const payload = { company: selectedCompany, account: selectedAccount, adjustment_ref, sub_account: selected_sub_account.ledger_label, amount: numericAmount };

    try {
      // API call to submit load request
      var response = await apiService({ method: "post", path: "/user/fund_sub_account", payload });
      setMasterAccount(response.data.sub_escrow_balances[0]);
      // Call onSubmit prop if provided
      onSubmit?.(payload);
      setSubLoads([]);
      setSelectedSubAccount({})
      setSelectedSubId('');
      // Reset form and close dialog
      setAmount("");
      setConfirmAmount("");
      setDialogOpen(false);
      setIsConfirmEnabled(true);

    } catch (error) {
      console.error("Submit API call failed:", error);
      // Optionally, you could show an error message to the user here
    }
  };

  return (
    <div className={styles.container}>
      {is_authorized == true && load_payout_master_access == 'true' && (
        <div className={styles.card}>
          <div className={styles.cardHeader}>Load Payout Sub-Account</div>

          <div className={styles.cardContent}>
            <div className={styles.masterBalance}>
              <span className={styles.masterLabel}>Payout Master Balance</span>
              <span className={styles.masterAmount}>
                ₹{masterAccount.balance ? masterAccount.balance : "0"}
              </span>
            </div>

            <div className={styles.inputSection}>
              <label htmlFor="subAccount" className={styles.label}>Choose Sub-Account</label>
              <select disabled={is_sub_account_detials_loading}
                id="subAccount"
                value={selectedSubId}
                onChange={(e) => {
                  setSelectedSubId(e.target.value)
                  handleSubAccountSelection(e.target.value)
                }}
                className={styles.select}
              >
                <option value="" selected disabled>Please select an Sub Account</option>
                {subAccounts.map((sa) => (
                  <option key={sa.ledger_label} value={sa.ledger_label}>{sa.ledger_label}</option>
                ))}
              </select>
            </div>
            <div> {is_sub_account_detials_loading ? "Loading ..." : ''} </div>
            {is_sub_account_detials_loading == false && selected_sub_account && (
              <>
                <div className={styles.subBalance}>
                  <span>Current Sub-Account Balance</span>
                  <span className={styles.subAmount}>
                    ₹ {selected_sub_account.balance} {selected_sub_account.cr_dr == 'Dr' ? ' Cr' : ' Dr'}
                  </span>
                </div>

                <div className={styles.section}>
                  <p className={styles.sectionTitle}>Last 5 Loads</p>
                  {subLoads.length ? (
                    <table className={styles.table}>
                      <thead>
                        <tr className={styles.tableHeaderRow}>
                          <td className={styles.tableHeading1}>Load ID</td>
                          <td className={styles.tableHeading}>Amount (₹)</td>
                          <td className={styles.tableHeading}>Time & Date</td>
                        </tr>
                      </thead>
                      <tbody>
                        {subLoads.slice(0, 5).map((l) => (
                          <tr key={l.adjustment_ref}>
                            <td>{l.adjustment_ref}</td>
                            <td style={{ textAlign: "right" }}>
                              {l.amount.toLocaleString("en-IN")}
                            </td>
                            <td style={{ textAlign: "right" }}>
                              {new Date(l.timestamp).toLocaleString("en-IN", { hour12: false })}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <p className={styles.noData}>No loads yet</p>
                  )}
                </div>
              </>
            )}

            <div className={styles.amountInputs}>
              <div className={styles.inputSection}>
                <label htmlFor="amt" className={styles.label}>Load Amount</label>
                <input
                  id="amt"
                  type="number"
                  min="0"
                  step="0.01"
                  placeholder="Enter amount (₹)"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  className={styles.input}
                />
              </div>
              <div className={styles.inputSection}>
                <label htmlFor="reAmt" className={styles.label}>Re-enter Load Amount</label>
                <input
                  id="reAmt"
                  type="number"
                  min="0"
                  step="0.01"
                  placeholder="Re-enter amount (₹)"
                  value={confirmAmount}
                  onChange={(e) => setConfirmAmount(e.target.value)}
                  className={styles.input}
                />
              </div>
            </div>

            {!amountsMatch && confirmAmount && (
              <div className={styles.error}>
                <svg className={styles.errorIcon} viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                </svg>
                Amounts do not match.
              </div>
            )}
            {!withinBalance && amount && (
              <div className={styles.error}>
                <svg className={styles.errorIcon} viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                </svg>
                Amount exceeds sub-account balance.
              </div>
            )}
            {duplicate && (
              <div className={styles.error}>
                <svg className={styles.errorIcon} viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                </svg>
                Duplicate of last successful load.
              </div>
            )}
          </div>

          <div className={styles.cardFooter}>
            <button disabled={!isValid && dialogOpen} onClick={handleSubmitAttempt}>Submit</button>
          </div>

          {dialogOpen && (
            <div className={styles.dialogContent}>
              <div>
                <div className={styles.heading}>Confirm Load</div>
              </div>
              <p className={styles.dialogText}>
                You are about to load <span className={styles.head33}>₹{numericAmount.toLocaleString("en-IN")}</span> into <span className={styles.head33}>{selected_sub_account?.ledger_label}</span>.
              </p>
              <div className={styles.dialogFooter}>
                <button onClick={() => {
                  setDialogOpen(false)
                }}>Cancel</button>
                <button disabled={!is_confirm_enabled} onClick={handleConfirm}>{is_confirm_enabled ? 'Confirm' : 'Processing ...'}</button>
              </div>
            </div>
          )}
        </div>
      )}
      {is_authorized == true && load_payout_master_access == 'false' && (
        <div className={styles.card}>
          <div className={styles.cardHeader}>Not A Load Payout Master Account</div>
        </div>
      )}
      {is_authorized == false && is_loading == false && (
        <div className={styles.card}>
          <div className={styles.errorHeader}>Not Authorized</div>
        </div>
      )}
      {is_loading && (
        <div className={styles.card}>
          <div className={styles.cardHeader}>is Loading ...</div>
        </div>
      )}
    </div>
  );
}